export default "__VITE_ASSET__197b6acd__"